import { JWTPayload } from '@/types/auth';

/**
 * Decode JWT token
 * @param token - JWT token string
 * @returns Decoded JWT payload or null if invalid
 */
export const decodeJWT = (token: string): JWTPayload | null => {
  try {
    const base64Url = token?.split('.')[1];
    if (!base64Url) return null;
    
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        ?.split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    return JSON.parse(jsonPayload) as JWTPayload;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

/**
 * Check if JWT token is expired
 * @param token - JWT token string
 * @returns True if token is expired or invalid
 */
export const isTokenExpired = (token: string): boolean => {
  const payload = decodeJWT(token);
  if (!payload || !payload.exp) return true;
  
  // JWT exp is in seconds, Date.now() is in milliseconds
  const currentTime = Math.floor(Date.now() / 1000);
  return payload.exp < currentTime;
};

/**
 * Get token expiry time
 * @param token - JWT token string
 * @returns Expiry time in milliseconds or null if invalid
 */
export const getTokenExpiry = (token: string): number | null => {
  const payload = decodeJWT(token);
  if (!payload || !payload.exp) return null;
  
  // Convert seconds to milliseconds
  return payload.exp * 1000;
};

